//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
/** Services Import */
import Global from '../../../Services/Common/Global';
import Commons from '../../../Services/Common/Common';
/** Components Import */
import M_TBM_BASIC_02 from './M_TBM_BASIC_02';
import { Loading } from '../../../Components/MUIs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../Reducer/CommonReducer';
//#endregion

function M_TBM_BASIC_02F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  //로그인한 user 정보

  const [inputs, setInputs] = useState({
    video: '',
    isNext: false,
  });
  const videoRef = useRef();
  const [played, setPlayed] = useState(0);
  const [play, setPlay] = useState(false);
  //#endregion

  useEffect(() => {
    Init();

    const timeout = setTimeout(() => {
      setPlay(true);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const Init = async () => {
    setLoading(true);
    try {
      await SearchLogic1();
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  // 동영상 조회
  const SearchLogic1 = async () => {
    setLoading(true);
    setInputs({
      ...inputs,
      video: '',
      isNext: true,
    });

    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R2',
            _userid: userInfo.userid,
            _authCd: Commons.EncryptAES(userInfo.authCd) || '',
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else {
          if (!data[0].VIDEO_LOCATION) {
            setInputs({
              ...inputs,
              video: '',
              isNext: true,
            });
          } else {
            const videoPath = data[0].VIDEO_LOCATION || '';
            const videoFullUrl = getFullFileUrl(videoPath);
            setInputs((prev) => ({
              ...prev,
              video: videoFullUrl,
            }));
          }
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 저장
  //#endregion
  //#region 삭제
  //#endregion
  //#region 나머지 함수
  // URL 인코딩 처리
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };
  const getFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = fixUrl(relativePath);
    return `${Global.file.useUrl}files/${fixedPath}`;
  };
  const HandleVideoError = (e) => {
    console.log('Video Error: ', e);
    if (e.type === 'error') {
      setInputs({
        ...inputs,
        video: '',
        isNext: true,
      });
    }
  };

  //비디오를 모두 시청 했는지 체크
  const HandleVideoEnd = () => {
    setInputs({
      ...inputs,
      isNext: true,
    });
  };

  const HandleProgress = (state) => {
    setPlayed(state.played);
  };

  const HandleSeek = (seekTime) => {
    if (!videoRef.current) return;

    try {
      const currentTime = videoRef.current.getCurrentTime();
      const duration = videoRef.current.getDuration();

      if (!duration || duration === 0) return;

      const playedFraction = currentTime / duration;
      if (playedFraction > played) {
        setPlayed(playedFraction);
      }
    } catch (error) {
      console.log('Seek Error: ', error);
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBM_BASIC_02
        userInfo={userInfo}
        lanList={lanInfo}
        inputs={inputs}
        setInputs={setInputs}
        videoRef={videoRef}
        play={play}
        setPlay={setPlay}
        setModalToggle1={props.setModalToggle1}
        modalToggle1={props.modalToggle1}
        setModalToggle2={props.setModalToggle2}
        modalToggle2={props.modalToggle2}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        check={props.check}
        setCheck={props.setCheck}
        userCount={props.userCount}
        // 함수
        HandleVideoError={HandleVideoError}
        HandleVideoEnd={HandleVideoEnd}
        HandleProgress={HandleProgress}
        HandleSeek={HandleSeek}
        ActiveButton={props.ActiveButton}
      />
      <Loading open={loading} />
    </div>
  );
}

export default M_TBM_BASIC_02F;
